import { Route, Redirect } from "react-router-dom";
import { isAuthorized, hasSelectedStore, isWaiterAuthorized, isStoreOpen } from "./authentication";

const AppRouter = ({ component: Component, layout: Layout, authorizedRequired, selectedStoreRequired, waiterAuthorizedRequired, shiftRequired, ...rest }) => {
	return (
		<Route 
		{...rest}
		render = {props => {
				if (authorizedRequired && !isAuthorized()) {
					return (<Redirect to={{ pathname: "/login" }} />);
				}

				if (selectedStoreRequired && !hasSelectedStore()) {
					return (<Redirect to={{ pathname: "/my-stores" }} />);
				}

				if (waiterAuthorizedRequired && !isWaiterAuthorized()) {
					return (<Redirect to={{ pathname: "/home" }} />);
				}

				if (shiftRequired && !isStoreOpen()) {
					return (<Redirect to={{ pathname: "/shift/start-day" }} />);
				}
				
				return (
					<Layout>
						<Component {... props} />
					</Layout>
				);
			}}
		/>
	);
};

export default AppRouter;